<template>
  <div class="accountPage">
    <div class="accountMenu paddingNormalTop paddingNormalBottom">
      <div class="row">
        <div class="three columns accountCard accountSidebar marginLargeRight ">
          <AccountMenu />
        </div>
        <div class="eight columns account-body-contents">
          <!-- Loop through all the cards in the drop down history. -->
          <div
            id="accountCard"
            class="accountCard"
          >
            <!-- Account Settings -->
            <AccountDetails v-if="card === 'Account Details'" />

            <!-- Create New Account -->
            <CreateAccountCard v-if="card === 'Create an Account'" />

            <!-- Account -->
            <div class="hideOnDesktop">
              <AccountMenu v-if="card === 'Account Menu'" />
            </div>

            <!-- Bids -->
            <BidsCard v-if="card === 'Bids'" />

            <!-- Favorites -->
            <FavoritesContainer v-if="card === 'Favorites'" />

            <!-- Notifications -->
            <NotificationsCard v-if="card === 'Notifications'" />

            <!-- Single Invoice -->
            <InvoiceCard v-if="card === singleInvoice" />

            <!-- Multiple Invoices -->
            <InvoiceList
              v-if="card === 'Invoices'"
              :title="'Invoices'"
              :group-by="'paid_status'"
            />

            <!-- Single Shipping Order -->
            <ShippingOrderCard v-if="card === 'Shipping Order'" />

            <!-- Multiple Shipping Orders -->
            <ShippingOrderList
              v-if="card === 'Shipping'"
              :title="'Shipping Orders'"
              :group-by="'require_action'"
            />

            <!-- Arrange Shipping or Pick up -->
            <ArrangeFullfillmentCard v-if="card === 'Arrange Shipping or Pick up'" />

            <!-- Shippihg Details -->
            <ShippingDetailsCard v-if="card === 'Shipping Details'" />

            <!-- Pick up Details -->
            <PickupDetailsCard v-if="card === 'Pick up Details'" />

            <!-- Consignments -->
            <ConsignmentList
              v-if="card === 'Consignments'"
              :list-title="'Auction Inventory'"
            />

            <!-- Close overflow container -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as menuConstants from '../constants/menu'
import CreateAccountCard from '../components/Cards/CreateAccount'
import AccountMenu from '../components/Cards/AccountMenu'
import AccountDetails from '../components/Cards/AccountDetails'
import BidsCard from '../components/Cards/Bids'
import FavoritesContainer from '../components/Favorites/FavoritesContainer'
import NotificationsCard from '../components/Cards/Notifications'
import InvoiceCard from '../components/Cards/Invoice'
import InvoiceList from '../components/InvoiceList'
import ShippingOrderCard from '../components/Cards/ShippingOrder'
import ShippingOrderList from '../components/ShippingOrderList'
import ArrangeFullfillmentCard from '../components/Cards/ArrangeFullfillment'
import ShippingDetailsCard from '../components/Cards/ShippingDetails'
import PickupDetailsCard from '../components/Cards/PickupDetails'
import ConsignmentList from './ConsignmentList.vue'

export default {
	name: 'AccountMenuDropdown',
	components: {
		AccountDetails,
		AccountMenu,
		ArrangeFullfillmentCard,
		BidsCard,
		CreateAccountCard,
		FavoritesContainer,
		InvoiceCard,
		InvoiceList,
		NotificationsCard,
		PickupDetailsCard,
		ShippingOrderCard,
		ShippingOrderList,
		ShippingDetailsCard,
		ConsignmentList
	},
	props: [
	  'invoice_id',
	  'shipping_order_id'
	],
	data () {
		return {
			'shiftLeftTitle': '',
			'hasBidsNotification': false 
		}
	},
	computed: {
		singleInvoice: function () {
			return menuConstants.MENU_ITEM_INVOICE_ITEM
		},
   	card: function() {
			return this.$store.getters.accountCardHistory.slice(0,1)[0]
		},
		pickupItems: function() {
			let pickupItems = []
			let self = this
			Object.keys(self.$store.getters.pickupItems).forEach(function (key) {
				pickupItems.push(self.$store.getters.pickupItems[key])
			})
			return pickupItems
		},
		accountMenuShiftLeft: function () {
			return this.$store.getters.accountMenuShiftLeft
		},
		activeAccountTab: function () {
			if (this.authenticated) {
				return 'main_menu'
			} else {
				return 'sign_in'
			}
			// return this.$store.getters.activeAccountTab
		},
		notifications: function () {
			return this.$store.getters.customerNotifications
		},
		authenticated: function () {
			return this.$store.getters.isAuthenticated
		},
		passwordResetCode: function () {
			if (this.getUrlParameter('reset_password')) {
				if (this.getUrlParameter('reset_password').length > 0) {
					let getData = JSON.parse(this.getUrlParameter('reset_password'))
					return getData.password_reset_code
				}
			}
			return ''
		}
	},
	watch: {},
	mounted () {
		this.insertAccountMenu(menuConstants.MENU_ITEM_ACCOUNT_DETAILS)
		if (typeof (this.invoice_id) != 'undefined') {
			if (this.invoice_id.length > 0) {
				this.$store.dispatch('updateCurrentInvoice', this.invoice_id)
				this.insertAccountMenu('Invoice')
			}
		}
		if (typeof (this.shipping_order_id) != 'undefined') {
			if (this.shipping_order_id.length > 0) {
				this.$store.dispatch('updateCurrentShippingOrder', this.shipping_order_id)
				this.insertAccountMenu('Shipping Order')
			}
		}
	},
	methods: {
		insertAccountMenu (payload) {
	  this.$store.dispatch('insertAccountHistory', payload)
		},
		deleteAccountMenu () {
	  this.$store.dispatch('deleteAccountHistory')
		},
		getUrlParameter: function (name) {
			 
			name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
			let regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
			let results = regex.exec(location.search)
			return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
		},
		processShippingArrangement (e) {
			let postData = {
				inventory_ids: []
			}
			for(let i=0; i<e.target.length; i++) {
				if(e.target[i].name == 'inventory_ids[]'){
					postData['inventory_ids'].push(e.target[i].value)
				} else if (e.target[i].name == 'pickup_type') {
					if(e.target[i].checked == true) {
						postData[e.target[i].name] = e.target[i].value
					}	
				} else {
					postData[e.target[i].name] = e.target[i].value
				}	
			}
			this.$store.dispatch('processShippingArrangement', postData)
		},
		getPickup () {
			this.$store.dispatch('getPickup')	
		}
	}
}
</script>

<style scoped>
.account-body-contents {
	background: #F5F5F5;
	border-radius: 8px;
	padding: 0 30px;
}
</style>
